import { render, staticRenderFns } from "./PartnersTariff.vue?vue&type=template&id=1a99a930"
import script from "./PartnersTariff.vue?vue&type=script&lang=js"
export * from "./PartnersTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports